var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-cascader',{attrs:{"filterable":"","show-all-levels":false,"options":_vm.areaSource,"placeholder":"请选择所在城市","field-names":{
    label: 'name',
    value: 'code',
    children: 'areaList',
  }},on:{"change":_vm.treeChange},model:{value:(_vm.treeValues),callback:function ($$v) {_vm.treeValues=$$v},expression:"treeValues"}})}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }